import React, { useEffect, useRef, useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import { apiPaymentStatus } from "../lib/api";
import { Sprout, Loader2, CheckCircle2 } from "lucide-react";

export default function PaymentReturn({ sessionId }) {
  const { refresh } = useAuth();
  const [msg, setMsg] = useState("Confirming your payment…");
  const [done, setDone] = useState(false);
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    let attempts = 0;
    const clearParam = () => window.history.replaceState(null, "", window.location.pathname);
    const poll = async () => {
      attempts += 1;
      try {
        const res = await apiPaymentStatus(sessionId);
        if (res.payment_status === "paid") {
          setMsg("Payment confirmed! Unlocking your workspace…");
          setDone(true);
          clearParam();
          setTimeout(() => refresh(), 900);
          return;
        }
        if (res.status === "expired") { setMsg("Payment session expired. Please try subscribing again."); clearParam(); return; }
      } catch { /* retry */ }
      if (attempts >= 10) { setMsg("Still processing. Please refresh in a moment."); clearParam(); return; }
      setTimeout(poll, 2500);
    };
    poll();
  }, [sessionId, refresh]);

  return (
    <div className="min-h-screen bg-forest-900 text-white flex flex-col items-center justify-center p-6">
      <div className="flex items-center gap-3 mb-8">
        <div className="h-10 w-10 rounded-md bg-ai flex items-center justify-center"><Sprout className="h-6 w-6" strokeWidth={2.4} /></div>
        <span className="font-heading font-extrabold text-2xl">Assort<span className="text-ai">IQ</span></span>
      </div>
      <div data-testid="payment-return" className="rounded-xl bg-white text-forest-800 p-8 text-center max-w-sm w-full">
        {done ? <CheckCircle2 className="h-10 w-10 text-action-keep mx-auto" /> : <Loader2 className="h-10 w-10 text-ai animate-spin mx-auto" />}
        <p className="mt-4 text-sm text-forest-600">{msg}</p>
      </div>
    </div>
  );
}
